export interface PillConfig {
  label: string;
  icon: string;
}

export interface PillLabels {
  registrations: PillConfig;
  checkedIn: PillConfig;
  notCheckedIn: PillConfig;
  totalExpected: PillConfig;
}

export function getPillLabels(isLegacyBall: boolean): PillLabels {
  if (isLegacyBall) {
    return {
      registrations: { label: 'Registrations', icon: '📋' },
      checkedIn: { label: 'Checked-In', icon: '✅' },
      notCheckedIn: { label: 'Not Checked-In', icon: '⏳' },
      totalExpected: { label: 'Total Expected', icon: '🎟️' },
    };
  }
  return {
    registrations: { label: 'Capacity', icon: '🏛️' },
    checkedIn: { label: 'Entered', icon: '✅' },
    notCheckedIn: { label: 'Not Entered', icon: '⏳' },
    totalExpected: { label: 'Total Expected', icon: '🎟️' },
  };
}
